import { render, staticRenderFns } from "./HomeV2.vue?vue&type=template&id=18406d13&"
import script from "./HomeV2.vue?vue&type=script&lang=js&"
export * from "./HomeV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports